"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VibescoutStaticStyles = void 0;
const scrollbar = `*::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px 1px rgba(37, 47, 67, 0.1);
    border-radius: 0 10px 0 10px;
    width: 11px;
    height: 11px;
    overflow: hidden;
    background-color: rgba(178, 188, 207, 0.2);
}

*::-webkit-scrollbar {
    width: 11px;
    height: 11px;
    background-color: rgba(255, 255, 255, 0.15);
}

*::-webkit-scrollbar-thumb {
    border-radius: 0 10px 0 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(49,53,58,0.3);
    background-color: #3d4761;
    background-image: linear-gradient(to bottom right, #2b4747, #252f43);
}
`;
const nodePageHeaderTextAnimation = `
:root {
  --node-color: black;
}

@keyframes nodeHeader {
  0% {
    transform: translate(0, 0);
    background: var(--node-color);
  }
  
  25% {
    transform: translate(0.1rem, 0.3rem); 
  }
  
  50% {
    transform: translate(-0.1rem, 0.15rem); 
  }
  
  0% {
    transform: translate(0, 0);
    background: var(--node-color);
  }
}`;
const svgDrawPathAnimation = `@keyframes drawPath {
    0% { stroke-dashoffset: 2000 }
    100% { stroke-dashoffset: 0 }
}`;
const loadingStripeAnimation = `@keyframes loadingStripe {
    0% { transform: translateX(-35em) }
    100% { transform: translateX(100%) }
}`;
const jetbrainsMonoFamily = `
@font-face {
  font-family: 'Jetbrains Mono';
  font-style: normal;
  font-weight: 400;
  src: local('Jetbrains Mono'), local('JetbrainsMono'), url(/_static/fonts/jetbrainsmono/jetbrainsmono-regular-webfont.woff2) format('woff2');
}

@font-face {
  font-family: 'Jetbrains Mono';
  font-style: italic;
  font-weight: 400;
  src: local('Jetbrains Mono Italic'), local('JetbrainsMono-Italic'), url(/_static/fonts/jetbrainsmono/jetbrainsmono-italic-webfont.woff2) format('woff2');
}

@font-face {
  font-family: 'Jetbrains Mono';
  font-style: normal;
  font-weight: 500;
  src: local('Jetbrains Mono Medium'), local('JetbrainsMono-Medium'), url(/_static/fonts/jetbrainsmono/jetbrainsmono-medium-webfont.woff2) format('woff2');
}

@font-face {
  font-family: 'Jetbrains Mono';
  font-style: italic;
  font-weight: 500;
  src: local('Jetbrains Mono Medium Italic'), local('JetbrainsMono-MediumItalic'), url(/_static/fonts/jetbrainsmono/jetbrainsmono-medium-italic-webfont.woff2) format('woff2');
}

@font-face {
  font-family: 'Jetbrains Mono';
  font-style: normal;
  font-weight: 700;
  src: local('Jetbrains Mono Bold'), local('JetbrainsMono-Bold'), url(/_static/fonts/jetbrainsmono/jetbrainsmono-bold-webfont.woff2) format('woff2');
}

@font-face {
  font-family: 'Jetbrains Mono';
  font-style: italic;
  font-weight: 700;
  src: local('Jetbrains Mono Bold Italic'), local('JetbrainsMono-BoldItalic'), url(/_static/fonts/jetbrainsmono/jetbrainsmono-bold-italic-webfont.woff2) format('woff2');
}`;
const robotoFontFamily = `
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  src: local('Roboto-Light'), url(/_static/fonts/roboto/Roboto-Light.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 300;
  src: local('Roboto-LightItalic'), url(/_static/fonts/roboto/Roboto-LightItalic.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  src: local('Roboto-Medium'), url(/_static/fonts/roboto/Roboto-Medium.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 500;
  src: local('Roboto-MediumItalic'), url(/_static/fonts/roboto/Roboto-MediumItalic.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  src: local('Roboto-Bold'), url(/_static/fonts/roboto/Roboto-Bold.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 700;
  src: local('Roboto-BoldItalic'), url(/_static/fonts/roboto/Roboto-BoldItalic.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 900;
  src: local('Roboto-Black'), url(/_static/fonts/roboto/Roboto-Black.ttf) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-style: italic;
  font-weight: 900;
  src: local('Roboto-BlackItalic'), url(/_static/fonts/roboto/Roboto-BlackItalic.ttf) format('truetype');
}`;
exports.VibescoutStaticStyles = {
    scrollbar,
    svgDrawPathAnimation,
    loadingStripeAnimation,
    jetbrainsMonoFamily,
    robotoFontFamily,
    nodePageHeaderTextAnimation,
};
